import request from './request'

export interface ChecklistItem {
  id: number
  item_id: string
  item_name: string
  item_name_zh: string
  type: string
  type_text: string
  section: string
  duration_minutes: number
  duration_text: string
  seasons: string[]
  frequency?: string
  photo_required: number
  follow_up_needed: number
  follow_up_care_plans: string[]
  follow_up_care_plans_text: string[]
  plan_values: {
    essential_care: number
    enhanced_care: number
    premium_care: number
  }
  values: {
    condition: string[]
    location: string[]
    task: string[]
    time: string[]
  }
  checklist_values: Record<string, unknown>
  follow_up_text: string
  icon_url: string
  sort: number
  status: number
  status_text: string
  create_time: string
  update_time: string
}

export interface ChecklistListParams {
  page: number
  page_size?: number // 修改为可选，允许前端不传，由后端使用默认值
  search_type?: string
  keyword?: string
  type?: string
  section?: string
  follow_up?: string
  duration_minutes?: number
  seasons?: string[]
  status?: number
}

export interface ChecklistCreateParams {
  item_name: string
  item_name_zh: string
  type: string
  duration_minutes: number
  seasons: string[]
  section: string
  frequency: string
  photo_required?: number
  follow_up_needed?: number
  plan_includes_follow_up_care?: string[]
  plan_values?: {
    essential_care: number
    enhanced_care: number
    premium_care: number
  }
  description: string
  description_zh: string
  icon_url?: string
  sort: number
  status: number
}

export interface ChecklistCreateResponse {
  code: number
  msg: string
  data: {
    list: ChecklistItem[]
    pagination: {
      page: number
      page_size: number
      total: number
      total_pages: number
    }
  }
}

export interface Pagination {
  page: number
  page_size: number
  total: number
  total_pages: number
}

export interface ChecklistListResponse {
  code: number
  msg: string
  data: {
    list: ChecklistItem[]
    pagination: Pagination
  }
}

export interface ChecklistItem {
  id: number
  item_id: string
  item_name: string
  item_name_zh: string
  type: string
  type_text: string
  section: string
  duration_minutes: number
  duration_text: string
  seasons: string[]
  photo_required: number
  repeatability: string
  follow_up_needed: number
  follow_up_care_plans: string[]
  follow_up_care_plans_text: string[]
  plan_values: {
    essential_care: number
    enhanced_care: number
    premium_care: number
  }
  values: {
    condition: string[]
    location: string[]
    task: string[]
    time: string[]
  }
  checklist_values: Record<string, unknown>
  follow_up_text: string
  icon_url: string
  description?: string
  description_zh?: string
  sort: number
  status: number
  status_text: string
  create_time: string
  update_time: string
}

export function getChecklistList(params: ChecklistListParams): Promise<ChecklistListResponse> {
  // return request.post('/api/admin/checklist/list', params)
  return request.post('/api/admin/checklist/list', params)
  //Edit by roshan
}

export function createChecklist(params: ChecklistCreateParams): Promise<ChecklistCreateResponse> {
  // return request.post('/api/admin/checklist/create', params)
  return request.post('/api/admin/checklist/create', params)
  //Edit by roshan
}

export function updateChecklistStatus(
  id: number,
  status: number,
): Promise<ChecklistCreateResponse> {
  // return request.post('/api/admin/checklist/update-status', { id, status })
  return request.post('/api/admin/checklist/update-status', { id, status })
  //Edit by roshan
}


export function parseChecklistResponse(response: ChecklistListResponse | null): {
  list: ChecklistItem[]
  total: number
  totalPages: number
} | null {
  if (response == null || response.code !== 200) return null
  return {
    list: response.data.list,
    total: response.data.pagination.total,
    totalPages: response.data.pagination.total_pages,
  }
}
